/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_GOOGLE_+': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 15',
    data: '<path pid="0" d="M7.63 6.47v2.46C9.09 9 10.54 9 12 9a4.05 4.05 0 0 1-2.47 2.74 5 5 0 0 1-5.37-1.15 4 4 0 0 1-1-1.6 4.53 4.53 0 0 1 3.13-5.86 5.56 5.56 0 0 1 4.49.87c.68-.61 1.31-1.25 1.93-1.9A7.89 7.89 0 0 0 7.25.29a7.43 7.43 0 0 0-7.2 6.52 5.45 5.45 0 0 0 0 .7 6 6 0 0 0 .07 1.12 7.36 7.36 0 0 0 5 5.71 7.75 7.75 0 0 0 8.2-2.07 7.86 7.86 0 0 0 1.58-5.79c-2.42-.02-4.85-.01-7.27-.01zM21.8 6.47V4.4h-2.18v2.07h-2.19v2.07h2.17v2.06h2.16V8.54H24V6.48h-2.2" _fill="#545454" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_GOOGLE_+.js